import { clsx } from 'clsx';

export interface EmptyStateProps {
  className?: string;
}

export const EmptyState = ({ className }: EmptyStateProps) => {
  return <span className={clsx('font-bold', className)}>No records</span>;
};
